export default "__VITE_ASSET__BTnRDTmE__"